import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import FormService from '../../../../core/services/FormService';
import GrammarCheckAnswersInput from './GrammarCheckAnswersInput';
import { isRequired, minLength } from '../../../../core/validations';
import ConfirmationDialogService from '../../../../core/services/ConfirmationDialogService';
import { get } from 'lodash';

class GrammarCheckAnswersInputContainer extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    values: PropTypes.object,
  };

  static defaultProps = {
    values: {},
    errors: {},
    disabled: false,
    submitting: false,
  };

  formService = new FormService();

  state = { answers: [] };

  componentDidMount() {
    this.formService.setInitialValues({});
    this.formService.validations = {
      text: [isRequired],
      slices: [isRequired, minLength(1)],
    };

    this.setState({ answers: get(this.props.values, 'answers', []) });
  }

  handleSubmit = () => {
    this.formService.setSubmitted();

    if (this.formService.errors) {
      return;
    }

    let updatedAnswers = [];

    if (!this.formService.getValue('id')) {
      updatedAnswers = [
        ...this.state.answers,
        {
          id: new Date().toISOString(),
          ...this.formService.getValues(),
          correct: true,
        },
      ];
    } else {
      updatedAnswers = this.state.answers.map((answer) => {
        if (answer.id === this.formService.getValue('id')) {
          const updatedSlices = this.formService.getValue('text').trim().split(' ');
          const slices = this.formService.getValue('slices').map((answer) => {
            return {
              ...answer,
              word: updatedSlices[answer.index],
            };
          });

          return {
            ...this.formService.getValues(),
            slices,
          };
        }
        return answer;
      });
    }

    this.setState({ answers: updatedAnswers }, () => {
      this.handleReset();
      this.props.onChange('answers', updatedAnswers);
    });
  };

  handleEdit = (id) => {
    this.formService.setInitialValues(this.state.answers.find((answer) => answer.id === id));
  };

  handleDelete = (id) => {
    ConfirmationDialogService.show('Delete Answer', 'You are about to delete the answer, are you sure?', () => {
      const updatedAnswers = this.state.answers.filter((answer) => answer.id !== id);

      this.setState(
        {
          answers: updatedAnswers,
        },
        () => {
          this.props.onChange('answers', updatedAnswers);
        }
      );
    });
  };

  handleReset = () => {
    this.formService.setInitialValues({});
    this.formService.reset();
  };

  render() {
    return (
      <GrammarCheckAnswersInput
        onChange={this.formService.setValue}
        onDelete={this.handleDelete}
        onReset={this.handleReset}
        onEdit={this.handleEdit}
        isDirty={this.formService.isDirty}
        errorText={get(this.props.errors, 'answers', null)}
        onSubmit={this.handleSubmit}
        values={this.formService.getValues()}
        errors={this.formService.errors}
        answers={this.state.answers}
      />
    );
  }
}

export default observer(GrammarCheckAnswersInputContainer);
